<template>
    <div>
        <div class="modal fade" :class="{ 'show d-block': modelValue }" tabindex="-1" role="dialog">
            <div class="modal-dialog" :class="size" role="document">
                <div class="modal-content shadow-lg border-0 rounded-4">

                    <div class="modal-header bg-primary rounded-top-4 py-3 px-4 d-flex align-items-center">
                        <div class="d-flex align-items-center gap-2">
                            <i v-if="icon" :class="'bi bi-' + icon" style="font-size: 1.3rem"></i>
                            <h5 class="modal-title mb-0 fw-semibold text-white">
                                {{ title }}
                            </h5>
                        </div>
                        <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
                    </div>

                    <div class="modal-body bg-white p-4 rounded-4 shadow-sm">
                        <slot></slot>
                    </div>

                </div>
            </div>
        </div>

        <div class="modal-backdrop fade show" v-if="modelValue"></div>
    </div>
</template>

<script>
export default {
    name: "ModalView",
    props: {
        modelValue: { type: Boolean, required: true },
        title: { type: String, required: true },
        icon: { type: String, default: null },
        size: { type: String, default: "modal-xl" } 
    },
    emits: ["update:modelValue", "close"],
    methods: {
        closeModal() {
            this.$emit("update:modelValue", false);
            this.$emit("close");
        }
    }
};
</script>

<style scoped>
.enhanced-modal {
    border-radius: 1rem;
    overflow: hidden;
    transition: transform 0.25s ease, opacity 0.2s ease;
}

.modal.show .enhanced-modal {
    transform: translateY(0);
    opacity: 1;
}

.modal.fade .enhanced-modal {
    transform: translateY(-10px);
    opacity: 0.9;
}

.modal-body .question-detail,
.modal-body .question-detail .form-control-plaintext,
.modal-body .question-detail .border {
    background-color: #fff !important;  
}

.modal-header .modal-title {
    font-size: 1.15rem;
    letter-spacing: 0.3px;
}

.btn-close-white {
    filter: brightness(0) invert(1);
    opacity: 0.8;
}

.btn-close-white:hover {
    opacity: 1;
}
</style>
